<template>
  <page-content></page-content>
</template>

<script>
/*home component from view directory by router*/

// components
import PageContent from './components/PageContent.vue';

export default {
  name: 'Home',
  components: {
    PageContent
  },
}
</script>
